import { styled } from "@phntms/css-components";
import { Swiper } from  'swiper/react';
import styles from "./styles.module.scss";
import Modal from "../Modal";

export const ModalSwiper = styled(Swiper, {
  css: styles.modalSwiper
})

export const ModalCarousel = styled(Modal, {
  css: styles.modalCarousel
})
